<div class="modal-header">
    <h4 class="modal-title">Yazdır</h4>
  </div>
  
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <form [formGroup]="form">
      <label>Pdf Şablonu Seç</label>
      <div class="form-group">
        <ng-select [items]="pdfs" bindLabel="pdfTitle" bindValue="id" formControlName="pdfId"></ng-select>
        <div *ngIf="form.get('pdfId').touched && form.get('pdfId').invalid" class="text-danger">
          <small *ngIf="form.get('pdfId').errors?.required">PDF şablonu seçimi zorunludur.</small>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
    <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="submitForm()">Yazdır</button>
  </div>
  